import styled from "styled-components";

import Link from "core/Link";

export const LinkContainer = styled.div`
    ${Link} {
        margin-left: 2em; // copies back-link class style margin - 30px
        text-transform: capitalize;
    }
`;
